import React from 'react';
import { PLATFORM_OPTIONS } from '../utils/constants';
import { AppleIcon, AndroidIcon, GlobeIcon } from './Icons';

const iconMap = {
  apple: AppleIcon,
  android: AndroidIcon,
  globe: GlobeIcon,
};

export const PlatformSelector = ({ value, onChange, label = 'Platforms', labelClassName = '' }) => (
  <div className="mb-5">
    {label && (
      <label className={`block text-sm mb-2 text-slate-800 ${labelClassName || 'font-semibold'}`}>
        {label}
      </label>
    )}
    <div className="flex flex-wrap gap-2">
      {PLATFORM_OPTIONS.map((option) => {
        const Icon = iconMap[option.icon];
        const isSelected = value.includes(option.value);
        const isDisabled = option.disabled;
        return (
          <button
            key={option.value}
            type="button"
            disabled={isDisabled}
            className={`flex items-center gap-2 px-3.5 py-2.5 border rounded-lg text-sm 
              font-sans transition-all
              ${isDisabled
                ? 'border-slate-100 bg-slate-50 text-slate-400 cursor-not-allowed'
                : isSelected
                  ? 'bg-purple-100 border-purple-500 text-purple-700 cursor-pointer'
                  : 'border-slate-200 bg-white text-slate-700 hover:border-slate-300 cursor-pointer'
              }`}
            onClick={() => !isDisabled && onChange(option.value)}
            title={isDisabled ? 'Coming soon' : undefined}
          >
            {Icon && <Icon size={16} />}
            {option.label}
            {isDisabled && <span className="text-xs text-slate-400">(soon)</span>}
          </button>
        );
      })}
    </div>
  </div>
);
